<template>
  <AppImg :src="`/images/stamps/${countryKeyToSlug(country)}.png`" :alt="$tt('stamp')" />
</template>

<script setup lang="ts">
import { countryKeyToSlug } from '~/helpers/format';
import type { CountryKey } from '~/types';

defineProps<{
  country: CountryKey;
}>();
</script>